import {PromotionType} from "../../promotion/helpers/PromotionType";
import {IVendorDetailPromotion} from "../components/detail/boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
}

export const getVendorPromotions = (props: IProps) => {
    const {promotions} = props;

    const hotOffers = promotions.filter((p) => p.type === PromotionType.LAST_MINUTE);
    const openDays = promotions.filter((p) => p.type === PromotionType.OPEN_DAYS);
    const restPromotions = promotions.filter((p) => p.type !== PromotionType.OPEN_DAYS && p.type !== PromotionType.LAST_MINUTE);
    return [...hotOffers.slice(0, 3), ...openDays.slice(0, 3), ...restPromotions.slice(0, 3)];
};
import {PromotionType} from "../../promotion/helpers/PromotionType";
import {IVendorDetailPromotion} from "../components/detail/boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
}

export const getVendorPromotions = (props: IProps) => {
    const {promotions} = props;

    const hotOffers = promotions.filter((p) => p.type === PromotionType.LAST_MINUTE);
    const openDays = promotions.filter((p) => p.type === PromotionType.OPEN_DAYS);
    const restPromotions = promotions.filter((p) => p.type !== PromotionType.OPEN_DAYS && p.type !== PromotionType.LAST_MINUTE);
    return [...hotOffers.slice(0, 3), ...openDays.slice(0, 3), ...restPromotions.slice(0, 3)];
};
